import styled from 'styled-components';
import { appearAnimation } from 'styles/animations';
import { BREAKPOINTS } from 'styles/media';

export const ModalOverlay = styled.div`
  align-items: center;
  background: rgba(23, 28, 51, 0.3);
  display: flex;
  height: 100vh;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 900000;
`;

interface ModalCloseButtonProps {
  buttonColor?: string;
}

export const ModalCloseButton = styled.button<ModalCloseButtonProps>`
  ${appearAnimation('1')}
  align-items: center;
  border: 0;
  cursor: pointer;
  display: flex;
  height: 32px;
  justify-content: center;
  position: absolute;
  top: 32px;
  right: 32px;
  width: 32px;
  z-index: 20;
  > svg {
    height: 12px;
    width: 12px;
    > path {
      fill: ${({ buttonColor = 'lightgray' }) => `var(--color-${buttonColor})`};
    }
  }
  ${BREAKPOINTS.mobile} {
    top: 16px;
    right: 16px;
    > svg {
      height: 16px;
      width: 16px;
    }
  }
`;

export const ModalContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
`;
